import { useQuery, UseQueryOptions } from '@tanstack/react-query';

interface BuildInfo {
  buildInfo: string;
}

export const fetchBuildInfo = async (): Promise<BuildInfo> => {
  const response = await fetch(`${window.location.origin}/build-info.json`, {
    headers: { 'Cache-Control': 'no-store' },
  });

  return response.json().catch(() => {
    throw new Error('Failed to fetch build-info.json');
  });
};

export const useBuildInfoQuery = (
  options?: UseQueryOptions<BuildInfo, unknown, BuildInfo, ['build-info']>,
) => {
  return useQuery(['build-info'], fetchBuildInfo, options);
};
